import Image from 'next/image'
import NextLink from 'next/link'

import type { TextProps } from '@wartek-id/text'
import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

interface BuktiKaryaCategoryItemType {
  key?: string
  href: string
  imageUrl?: string | null
  title: string
  description: string
  badgeIcon?: React.ReactNode | null
  icon?: React.ReactNode | null
  badgeIconName?: string | null
  iconName?: string | null
}

interface BuktiKaryaCategoryItemTypeProps extends BuktiKaryaCategoryItemType {
  isLoading?: boolean
  image?: React.ReactNode | null
  titleTextProps?: TextProps
  subtitleTextProps?: TextProps
  titleInfoTextProps?: TextProps
  titleInfoText?: string
  containerClass?: string
  preTitleNode?: React.ReactNode | null
  postTitleNode?: React.ReactNode | null
}

/**
 * @deprecated Bukti Karya is no longer served from guru-frontend and this is no longer maintained
 */
export function BuktiKaryaListSectionitem(
  props: BuktiKaryaCategoryItemTypeProps
) {
  const {
    href,
    title,
    description,
    icon = null,
    imageUrl = null,
    badgeIcon = null,
    badgeIconName = null,
    iconName = null,
    image = null,
    titleTextProps = {
      variant: 'subheading',
    },
    subtitleTextProps = {
      variant: 'helper',
      className: 'mt-1',
      color: 'subdued',
    },
    titleInfoTextProps = null,
    titleInfoText = null,
    containerClass = null,
    preTitleNode = null,
    postTitleNode = null,
  } = props

  const iconToRender = () => {
    if (icon) {
      return icon
    }

    if (iconName) {
      return <Icon>{iconName}</Icon>
    }

    if (image) {
      return image
    }

    if (imageUrl) {
      return <Image src={imageUrl} alt={title} width={24} height={24} />
    }

    return null
  }

  const badgeToRender = () => {
    if (badgeIcon) {
      return badgeIcon
    }

    if (badgeIconName) {
      return (
        <Icon
          color="critical"
          className="ml-2"
          // TODO: hacky way because tailwindcss fontsize doenst work on Icon Component
          style={{ fontSize: '8px' }}
          as="i"
        >
          {badgeIconName}
        </Icon>
      )
    }

    return null
  }

  interface ILinkProps {
    isExternalLink?: boolean
    href: string
    children: React.ReactNode
  }

  const Link = ({ isExternalLink = false, href, children }: ILinkProps) => {
    return isExternalLink ? (
      <a href={href}>{children}</a>
    ) : (
      <NextLink href={href} passHref>
        <a>{children}</a>
      </NextLink>
    )
  }

  return (
    <Link href={href} isExternalLink={true}>
      <div
        className={`my-2 mt-1 flex w-full flex-row justify-between items-center border-b bg-white border-disabled ${containerClass}`}
      >
        <div className="py-2 mb-2">
          <div className="flex flex-row justify-between">
            <div className="flex flex-shrink-0">{iconToRender()}</div>

            <div className="flex-row ml-4">
              {preTitleNode}
              {titleInfoText && (
                <Text {...titleInfoTextProps}>{titleInfoText}</Text>
              )}

              <div className="flex items-center">
                <Text {...titleTextProps}>{title}</Text>
                {badgeToRender()}
              </div>
              {postTitleNode && postTitleNode}
              <Text {...subtitleTextProps}>{description}</Text>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
